<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: 'App',
  data() {
    return {
      domain: '',
      defaultTitle: '网校',
      defaultIcon: ''
    }
  },
  created() {
    this.getDomian()
  },
  methods: {
    ...mapMutations(['saveDomain']),
    getDomian() {
      if (process.env.NODE_ENV === 'production') {
         this.domain = location.host
        // this.domain = 'wx-adia.shkt.online'
      } else {
         this.domain = 'wx-adia.tenghuiketang.com' // 测试环境
        // this.domain = 'wx-adia.shkt.online' // 生产环境
      }
      this.saveDomain(this.domain)
      this.$store.dispatch('getOrgID', this.domain)
      this.$store.dispatch('getWebInfo', this.domain).then((data) => {
        // 设置favicon
        document.querySelectorAll("link[rel*='icon']").forEach(item => {
          item.href = data.web_header_icon || this.defaultIcon
        })
        // 设置网站标题
        document.title = data.web_company_name || this.defaultTitle
      })
    }
  },
  updated() {
    window.scroll(0, 0)
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
}
.cursor-pointer {
  cursor: pointer;
}
</style>